import {
    ApiManager,
    sessionService,
    SessionManager,
    EnumUtility,
    SharedService
} from '../components/ComponentsLibrary';

import { ClientType } from '../enums/ClientType';
import { MasterEnum } from "../enums/MasterEnum";

const checkConfidential = (caseData) => {
    return [ClientType.DataMapType.FVI_And_Confidential_Case,
    ClientType.DataMapType.Confidential_Case].includes(caseData?.caseRestrictedTypeID) || (caseData?.confidentialCase === "Y")
};


// const checkFamilyViolence = (caseData) => (
//     (caseData?.caseRestrictedTypeID === ClientType.DataMapType.FVI_And_Confidential_Case) ||
//     (caseData?.familyViolence != null && caseData?.familyViolence.trim() !== "")
// )

const checkFamilyViolence = (caseData) => (
    caseData?.familyViolence === "Y" || 
    (caseData?.familyViolence != null && caseData?.familyViolence.trim() !== "" && caseData?.familyViolence.trim() !== "_" && caseData?.familyViolence.trim() !== "N")
)

const checkCaseClosed = (caseData) => {
    return caseData?.statusTypeID === ClientType.DataMapType.Closed
}


const getCPNCPNDI = async(caseData) => {
        const params = {
            DropdownCategoryTypeID: ClientType.DropdownCategoryType.CP_NCP_NDI_IND
        };
        const NDITypes = await ApiManager.GetAllDropdownTypes(params);
        const NDIMessage = NDITypes.find(x => x.dropdownTypeID === caseData.cpncp_NDI_IND)?.dropdownTypeName;
    return NDIMessage ?? 'Non-Disclosure: UNKNOWN';
}

const checkSpecialCircumstance = (caseData) => (
    caseData?.specialCircumstanceContentActive === 1
)

const getWarningMessageContent = async(messageContentID, stateID) => {
    // get message content
    const messageContentApiData = await ApiManager.getMessageContent({
        messageContentID,
        stateID
    })
    return {
        NotificationType: "warning", Title: "Warning", 
        Message: messageContentApiData?.[0].messageText
    };
}

const DataMapTranslate = async (dataMapCategoryTypeID, mapInputText, forceDatabase, alternateMapInputText) => {
    const dataMapList = await ApiManager.getDataMap({
        dataMapCategoryTypeID,
    });


    // IF mapInputText looks like an 8 digit date I want to convert it to: CCYY/MM/DD. KS uses a date to indicate it was closed on that date. 
    const safeInput = (mapInputText ?? '').toString().trim();

    if (/^\d{8}$/.test(safeInput)) {
        mapInputText = `${safeInput.substring(0,4)}/${safeInput.substring(4,6)}/${safeInput.substring(6,8)}`;
    } else {
        mapInputText = safeInput;
    }

    let dataMapValue;
 
    if (forceDatabase === true) {
        
        // In this case we're matching based on DataMapTypeId rather than a true mapinputtext
        const dataMapTypeId = Number(mapInputText);

        dataMapValue = dataMapList.find(
            dataMap => dataMap.dataMapTypeID === dataMapTypeId
        );
    } else {
        dataMapValue = dataMapList.find((dataMap) => (dataMap.mapInputText ?? '').toString().trim() === mapInputText);
    }

    // Some case data contains both the Y-Trac mapping ID and the state-system
    // input value. Preserve the existing precedence by trying the ID first and
    // the input text second before resolving the category default.
    if (!dataMapValue && alternateMapInputText !== undefined) {
        const safeAlternateInput = (alternateMapInputText ?? '').toString().trim();
        dataMapValue = dataMapList.find(
            (dataMap) => (dataMap.mapInputText ?? '').toString().trim() === safeAlternateInput
        );
    }

    if (dataMapValue) return dataMapValue
    

    // if not found, then search for default value
    
    // Find the category for this dataMapCategoryTypeID
    const DMdefval = dataMapList.find(dm => dm.dataMapCategoryTypeID === dataMapCategoryTypeID);
    
    if (DMdefval && DMdefval?.defaultValue !== undefined) {
        let iDefVal = DMdefval?.defaultValue;
        let searchCategoryTypeID = dataMapCategoryTypeID;
        
        if (iDefVal === 0) searchCategoryTypeID = 0; // if no default is really given (0), then look for special placeholder default value
        
        const cat = dataMapList.find(dm => dm.dataMapCategoryTypeID === searchCategoryTypeID && dm.dataMapTypeID === iDefVal);
        if (cat) return cat;
    }
    
    // if we haven't returned with success
    return {
        dataMapTypeID: 0,
        mapOutputText: "UNKNOWN"
    };
}


const buildYTracCaseData = async (caseData, stateID, forceDatabase = false) => {
    //console.log("BUILD YTRAC CASE DATA", caseData)

    const integrationInfo = JSON.parse(SessionManager.GetValueFromSession(SessionManager.IntegrationInfoKey) || '[]');

    // If integrationInfo does not have an array with integrationCategoryTypeID == MasterEnum.IntegrationCategoryType.Host then forceDatabase should be true. 
    if (!integrationInfo.some(integration => integration.integrationCategoryTypeID == MasterEnum.IntegrationCategoryType.Host)) {
        forceDatabase = true;
    }

    // // For Case Status
    const caseStatusDM = await DataMapTranslate(ClientType.DataMapCategoryType.Status_Type, caseData.caseStatusID, forceDatabase);
    
    if (caseStatusDM?.dataMapTypeID) {
        caseData = {...caseData, statusTypeID: caseStatusDM.dataMapTypeID, caseStatus: caseStatusDM.mapOutputText, statusTypeName: caseStatusDM?.mapOutputText}
    }

    // For Case Type, first match an existing Y-Trac mapping ID, then try the
    // state-system input text, and finally use the configured category default.
    const caseTypeDM = await DataMapTranslate(
        ClientType.DataMapCategoryType.Case_Type,
        caseData.caseTypeID,
        true,
        caseData.caseType
    );

    if (caseTypeDM?.dataMapTypeID) {
        caseData = {
            ...caseData,
            caseTypeID: caseTypeDM.dataMapTypeID,
            caseType: caseTypeDM.mapOutputText
        };
    }


    // Always apply datamap translation for confidentialCase  
    const confidentialDM = await DataMapTranslate(ClientType.DataMapCategoryType.Confidential_Case, caseData.confidentialCase);
    caseData = {
        ...caseData,
        caseRestrictedTypeID: confidentialDM?.dataMapTypeID || caseData.caseRestrictedTypeID,
        caseRestrictedTypeName: confidentialDM?.mapOutputText || caseData.caseRestrictedTypeName
    };
    
    // Always apply datamap translation for familyViolence
    // TODO This state specific code is temporary. It needs to fixed in the DataMap refactoring.
    if (stateID === EnumUtility.StateIDKey.Colorado.ID) {
        // created separate chip for NDI
        if (caseData?.cpncp_NDI_IND) {
            const NDIMessage = await getCPNCPNDI(caseData);
            caseData = { ...caseData, ndiChipDisplay: NDIMessage  }; 
        } else {
            caseData = { ...caseData, ndiChipDisplay: "" };
        }
    } else {
        const fviDM = await DataMapTranslate(ClientType.DataMapCategoryType.Family_Violence, caseData.familyViolence);
        caseData = {
            ...caseData,
            familyViolence: fviDM?.mapOutputText && fviDM?.mapOutputText !== "UNKNOWN"  ?  fviDM?.mapOutputText : 'Family Violence: UNKNOWN',  //caseData.familyViolence
            fviChipDisplay: fviDM?.mapOutputText && fviDM?.mapOutputText !== "UNKNOWN" ? fviDM?.mapOutputText : 'Family Violence: UNKNOWN'  //caseData.familyViolence
        };
        //  // Then determine if chip should be shown based on the translated value
        // if (checkFamilyViolence(caseData)) {
        //     caseData = {
        //         ...caseData,
        //         fviChipDisplay: caseData.familyViolence
        //     };
        // } else {
        //     caseData = {
        //         ...caseData,
        //         fviChipDisplay: ""
        //     };
        // }
    }
    
    return caseData
}


//This will be used for NextWorkItem, not for New WorkItem; this is to elevate Active WFs to Supervisor when searcher had no permission for Confidential case.
const getActiveWorkflowActions = async (caseID, userLoginID, stateID, masterServerDBSchema) => {
    const params = {
        caseNumber: caseID,
        moduleID: 1,
        userLoginID,
        yTracSiteID: stateID,
        masterServerDBSchema: masterServerDBSchema,
    };
    const activeWorkflowActions = await ApiManager.getActiveWorkflowActions(params);
    return activeWorkflowActions;
} 

//This will be used for to lock or unlock CaseWorkflow by CaseWorkflowID
const lockOrUnLockCaseWorkflow = async (caseWorkflowID, lockValue, userLoginID, masterServerDBSchema) => {
    const params = {
        caseWorkflowID: caseWorkflowID,
        lockValue: lockValue, // 1-Lock, 0-Unlock
        fkm_UserLoginID: userLoginID,
        masterServerDBSchema: masterServerDBSchema,
    };
    const result = await ApiManager.LockUnlockCaseWorkflowByCaseWorkflowID(params);
    return result;
}

//This will be used for to unlock CaseWorkflows by UserLoginID
const unlockCaseWorkflowsByUser = async (userLoginID) => {
    const params = {
        userLoginID: userLoginID,
    };
    const result = await ApiManager.UnlockCaseWorkflowsByUserLoginID(params);
    return result;
}


const workflowTakeAction = async (caseWorkflowActions, caseWorkflow, wfd, caseNumber, siteID, masterServerDBSchema, userLoginID) => {
    const nextWorkflowID = (wfd.WCL_WorkflowID == null ? null : wfd.WCL_WorkflowID);
    const parameters = {
        caseNumber,
        caseWorkflowID: caseWorkflow.caseWorkflowID,
        workflowDetailID: wfd.workflowDetailID,
        workflowDetailName: wfd.workflowDetailName,
        childWorkflowID: nextWorkflowID,
        nextStepDueTS: caseWorkflow.nextStepDueTS,
        userLoginID: userLoginID,
        masterServerDBSchema,
        yTracSiteID: siteID,
        caseWorker: caseWorkflowActions.CaseWorker,
        cPMemberID: caseWorkflowActions.cPMemberID,
        nCPMemberID: caseWorkflowActions.nCPMemberID,
        cPFirstName: caseWorkflowActions.cPFirstName,
        cPLastName: caseWorkflowActions.cPLastName,
        nCPFirstName: caseWorkflowActions.nCPFirstName,
        nCPLastName: caseWorkflowActions.nCPLastName,
        zipCode: caseWorkflowActions.zipCode,
        caseTypeID: caseWorkflowActions.caseTypeID,
        districtID: caseWorkflowActions.districtID,
        countyID: caseWorkflowActions.countyID,
        termParent: null,
        initialWorkflowStepID: null,
        workflowMapID: null,
        activityStartTS: null,
        workflowStateLockoutTimer: null,
        preview: 0, // better to send 0 instead of null
        noteID: null,
        contactID: null,
        ignoreUserOnlyLock: 0 // backend expects byte
    };
    await ApiManager.postTakeAction(parameters)
}

//This will be used for NextWorkItem, not for New WorkItem; this is to elevate Active WFs to Supervisor when searcher had no permission for Confidential case.
const createEscalationNotificationMessage = async (caseData, userLoginInfo, masterServerDBSchema) =>{
    const { siteID, stateID, legacyUserID } = userLoginInfo; 
    let referredWorkflow = 0;
    const result = await ApiManager.GetSettingsDetailValuesFromApi({
            settingsDetailIDList: String(ClientType.SettingsDetail.Workflow_Parameters__Confidential_Case_Criteria),
            ytracSiteID: stateID
    });
    const strInput = result?.settingDetailsApiData?.[0]?.settingsDetailValue || "";
    const criteriaList = strInput.split('|')
    const caseWorkflowActions = await getActiveWorkflowActions(caseData?.caseNumber, legacyUserID, stateID, masterServerDBSchema)
    for (const caseworkflow of caseWorkflowActions[0].caseWorkflows) {
        const wfd = caseworkflow.workflowDependency.find((dependency) => criteriaList.some((criteria) => dependency.workflowDetailName.includes(criteria)))
        if (wfd != null) {
            await workflowTakeAction(caseWorkflowActions[0], caseworkflow, wfd, caseData?.caseNumber, siteID, masterServerDBSchema, legacyUserID) //escalate to supervisor
            referredWorkflow++
        }
    }
    
    // get message content
    const partOneResult = await SharedService.getMessageContent(ClientType.MessageContent.V_MF4033_Confidential_Case_Message_Part_One);
    const partOneMessage = partOneResult?.messageText
    const partTwoResult = await SharedService.getMessageContent(ClientType.MessageContent.V_MF4034_Confidential_Case_Message_Part_Two);

    const partTwoMessage = partTwoResult?.messageText
    const dialogContent = {
        NotificationType: "warning", Title: "Warning", 
        Message: partOneMessage.replace("{0}", caseData.caseNumber) + partTwoMessage.replace("{0}", referredWorkflow),
        
    };
    return dialogContent
}

const CaseWorkflowService = {
    buildYTracCaseData,
    createEscalationNotificationMessage,
    checkConfidential,
    checkFamilyViolence,
    checkCaseClosed,
    getCPNCPNDI,
    lockOrUnLockCaseWorkflow,
    unlockCaseWorkflowsByUser,
    checkSpecialCircumstance,
    DataMapTranslate,
    getActiveWorkflowActions
}
export default CaseWorkflowService
